module.exports = __webpack_public_path__ + "static/media/sound-error-box.1baf9990.mp3";